import { connect } from 'react-redux';
import styled from 'styled-components';
import { Identifiable, Optional } from '@mews/std';
import { ApplicationState, WithScope, CommanderThunkDispatch } from '@mews-commander/types';
import { OptimusPlainLink, Empty } from '@mews-commander/ui';
import { alpha, getToken } from '@optimus-web/core';
import { startEntityEditing } from '../../entityManagement';

const EmptyPlainLink = styled(OptimusPlainLink)`
    color: ${({ theme }) => alpha(getToken('paletteBrandNight1000')({ theme }), getToken('opacity800')({ theme }))};
`;

interface DispatchProps {
    onEdit: () => void;
}

interface EditLinkProps extends DispatchProps {
    name: Optional<string>;
}

const EditLink = ({ onEdit, name }: EditLinkProps) =>
    name ? (
        <OptimusPlainLink onClick={onEdit} inherit>
            {name}
        </OptimusPlainLink>
    ) : (
        <EmptyPlainLink onClick={onEdit} inherit>
            <Empty textAlign="left" />
        </EmptyPlainLink>
    );

export default connect<{}, DispatchProps, WithScope & Identifiable, ApplicationState>(
    null,
    (dispatch: CommanderThunkDispatch, { id, scope }) => ({
        onEdit: () => dispatch(startEntityEditing(id, scope)),
    })
)(EditLink);
